<template>
    <div class="container-inner">
        <div class="searchMonth">
            <span>表示月：</span>
            <Datepicker class="datepicker" :disabled-dates="{ from: firstDateOfNextMonth }" :maximumView="'month'"
                :minimumView="'month'" format="yyyy-MM" v-model="firstDateOfthisMonth" :language="ja"
                placeholder="開始日" />

            <!-- 新しいAPIが増えた場合serverside「Libs\ApiRerun」にコマンド追加必須 -->
            <template v-if="AdTabActive == 0">
                <Button class="rerunButton" @click="rerun()">再実行</Button>
            </template>
        </div>


        <div class="AdMediaApiWrapper">
            <div class="api-tab">
                <button class="AdTabBtn" v-bind:class="{ 'active': AdTabActive == 0 }"
                    @click="showRegularAd">自社広告</button>
            </div>
            <div class="api-logs">

                <!-- 自社広告履歴 -->
                <table v-if="AdTabActive == 0">
                    <thead>
                        <tr>
                            <th class="th_sticky">完了日</th>
                            <th v-for="(medium, index) in media.api" :key="index">
                                {{ medium[1] }}
                            </th>
                        </tr>
                        <tr>
                            <th class="th_sticky"></th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                            <th>完了時刻 [対象期間] 結果</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(apiLogByDate, date) in apiLogs" :key="date">
                            <td class="date td_sticky" nowrap>{{ date }}</td>
                            <td v-for="(medium, mediumId) in media.api" :key="mediumId">
                                <div class="log" v-for="(log, index) in apiLogByDate[medium[0]]" :key="index">
                                    <span class="time">{{ log.finishTime }}</span>
                                    <span class="bracket">[</span>
                                    <span>{{ log.startDate }}</span>
                                    <span>〜</span>
                                    <span>{{ log.endDate }}</span>
                                    <span class="bracket">]</span>
                                    <span class="result" v-if="log.isSuccess">完了</span>
                                    <span class="error result" v-else>失敗</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="loading-window" v-show="this.$store.state.loading">
            <div class="loading-window-inner">
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale';

export default {
    data() {
        return {
            apiLogs: {},
            ja: ja,
            firstDateOfthisMonth: null,
            firstDateOfNextMonth: null,
            AdTabActive: 0,
        }
    },
    components: {
        Datepicker
    },
    created: function () {
        const date = new Date();
        date.setDate(1);
        this.firstDateOfNextMonth = new Date(date.setMonth(date.getMonth()));
        this.firstDateOfthisMonth = new Date();
        this.getApiLogs();
    },
    methods: {
        getApiLogs: async function () {
            this.$store.dispatch('loading', true);
            const month = (this.firstDateOfthisMonth.getFullYear()) + '-' + (this.firstDateOfthisMonth.getMonth() + 1);
            const res = await this.axios.get('/api/apiLogs', {
                params: {
                    month: month
                }
            });
            this.apiLogs = res.data;
            this.$store.dispatch('loading', false);
        },

        //再実行ボタンクリック処理
        rerun() {
            this.$store.dispatch('loading', true);
            this.axios.post('/api/rerun')
                .then(() => {
                    this.getApiLogs();
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch('loading', false);
                });
        },

        showRegularAd: function () {
            this.AdTabActive = 0;
            this.getApiLogs();
        },
    },
    watch: {
        firstDateOfthisMonth: function () {
            this.getApiLogs();
        }
    },
    computed: {
        ...mapGetters({
            media: 'media/allmedia'
        }),
    }
}
</script>

<style scoped lang="sass">
.container-inner
    overflow: hidden
    font-size: 12px
    .searchMonth
        display: flex
        align-items: center
        margin: 80px 140px 20px
        .rerunButton
            margin-left: 20px
    .AdMediaApiWrapper
        margin: 30px 140px 0
    .api-tab
        display: flex
        align-items: flex-end
        gap: 3px
        .AdTabBtn
            display: flex
            justify-content: center
            align-items: center
            width: 200px
            height: 30px
            border: none
            background: #C0C0C0
            border-radius: 5px 5px 0 0
            color: #FFF
            font-size: 1.2rem
            cursor: pointer
            &.active
                height: 38px
                background: $grayColor
    .api-logs
        max-height: 800px
        max-width: 1600px
        overflow: auto
        &::-webkit-scrollbar
            width: 5px
        &::-webkit-scrollbar-thumb
            background-color: $mainColor
        &::-webkit-scrollbar-track
            background-color: #dcdcdc
        table
            thead
                background-color: $mainColor
                color: $whiteColor
                position: sticky
                top: 0
                z-index: 2
                transform: translateZ(0);
                &:before
                    border-bottom: 2px solid $grayColor
                    content: ""
                    position: absolute
                    top: -21px
                    left: 0px
                    width: 100%
                    height: 100%
                    transform: translateZ(0);
                th
                    padding: 3px 6px
                    border: solid 2px $grayColor
                    white-space: nowrap
                .th_sticky
                    position: sticky
                    left: 0
                    z-index: 1
                    background: none;
                    border: none;
                    &:before
                        content: "";
                        position: absolute;
                        top: -1.5px;
                        left: 0;
                        width: 100%;
                        height: 90%;
                        border: 2px solid $grayColor;
                        background: $mainColor;
                        z-index: -1;
            tbody
                background-color: $whiteColor
                td
                    border: solid 2px $grayColor
                    padding: 4px
                    white-space: nowrap
                    .log
                        margin: 3px auto
                        .error
                            color: red
                        .time, .result
                            margin: 0px 12px
                        .bracket
                            margin: 0px 3px
                .td_sticky
                    position: sticky
                    left: 0
                    z-index: 1
                    background: none;
                    border: none;
                    &:before
                        content: "";
                        position: absolute;
                        top: -1.5px;
                        left: 0;
                        width: 100%;
                        height: 98%;
                        border: 2px solid $grayColor;
                        background: $whiteColor;
                        z-index: -1;
    .loading-window
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loading-window-inner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
@include sp()
    .container-inner
        .searchMonth
            margin: 60px 10px 20px
        .AdMediaApiWrapper
            margin: 30px 10px 0
</style>
